// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__ZOR9C","selects":"Documents_selects__KuHhM"};